import { render } from "./ProcessOfAvailment.vue?vue&type=template&id=0f839746"
import script from "./ProcessOfAvailment.vue?vue&type=script&lang=js"
export * from "./ProcessOfAvailment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__